import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { parseApiInstant } from '../util/parse-api-instant';

/**
 * Formatea un instante API (ISO UTC) en la zona horaria del navegador.
 */
@Pipe({
	name: 'formatInstant',
	standalone: false,
})
export class FormatInstantPipe implements PipeTransform {
	private readonly datePipe: DatePipe;

	constructor(@Inject(LOCALE_ID) locale: string) {
		this.datePipe = new DatePipe(locale || 'en-US');
	}

	transform(
		value: string | Date | null | undefined,
		format: string = 'medium'
	): string {
		if (!format) format = 'medium';
		const instant = parseApiInstant(value);
		if (!instant) return '';
		return this.datePipe.transform(instant, format) ?? '';
	}
}
